import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import maraschino1 from '../assets/images/maraschino-menu.jpg';
import maraschino2 from '../assets/images/maraschino-recipe-list.jpg';
import maraschino3 from '../assets/images/maraschino-recipe.jpg';
import '../assets/styles/Project.scss';
import Chip from '@mui/material/Chip';

interface TechStack {
    label: string;
}

const labelsMaraschino: string[] = [
    "React Native",
    "TypeScript",
    "JavaScript",
    "Supabase",
    "PostgreSQL"
];

const labelsAMPScriptEngine: string[] = [
    "VS Code",
    "TypeScript",
    "JavaScript",
    "Node.js",
]

const gradient = (color1: string, color2: string): string => {
    return `linear-gradient(45deg, ${color1}, ${color2})`;
}

function Development() {
    return (
        <div className="projects-container" id="development">
            <div className="page-contents">
                <h1>Development</h1>
                <div className="projects-grid">
                    <div className="project">
                        {/* <a href="https://www.filmate.club/" target="_blank" rel="noreferrer">
                        <img src={mock10} className="zoom" alt="thumbnail" width="100%" />
                    </a> */}
                        <div style={{ background: gradient('#36d1dc', '#5b86e5'), width: '100%', padding: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px' }}>
                            <a href="https://apps.apple.com/us/app/maraschino/id1673606125" style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1%' }} target="_blank" rel="noreferrer">
                                <img src={maraschino1} alt="thumbnail" width="25%" style={{borderRadius: 10}} />
                                <img src={maraschino2} alt="thumbnail" width="25%" style={{borderRadius: 10}} />
                                <img src={maraschino3} alt="thumbnail" width="25%" style={{borderRadius: 10}} />
                            </a>
                        </div>
                        <a href="https://apps.apple.com/us/app/maraschino/id1673606125" target="_blank" rel="noreferrer">
                            <h2>Maraschino</h2>
                        </a>
                        <p>Maraschino is a cocktail recipe app for iOS available on the App Store.</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsMaraschino.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                    <div className="project">
                        {/* <a href="https://yujisatojr.itch.io/highspeedchase" target="_blank" rel="noreferrer">
                        <img src={mock09} className="zoom" alt="thumbnail" width="100%" />
                    </a> */}
                        <div style={{ background: gradient('#ff7e5f', '#feb47b'), width: '100%', padding: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '10px' }}></div>

                        {/* <a href="https://yujisatojr.itch.io/highspeedchase" target="_blank" rel="noreferrer"> */}
                        <h2>AMPScript Engine</h2>
                        {/* </a> */}
                        <p>An Interpreter for AMPScript, which is a language used in Salesforce Marketing Cloud, built as a VS Code Extension.</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {labelsAMPScriptEngine.map((label, index) => (
                                <Chip key={index} className='chip' label={label} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Development;